import NotificationType from '../NotificationType';

export default class UserImportComplete extends NotificationType {
  get icon() {
    return 'fa-solid fa-file-import';
  }

  resolveRoute(notification) {
    const id = notification?.params?.user_csv_import_id;
    if (!id) return { name: 'admin-users-listing' };
    return { name: 'admin-user-csv-import-results', params: { id } };
  }
}
